<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.aboutKubaparis();
        return {
            props: {
                query,
            },
        };
    };
</script>

<script lang="ts">
    import type { AboutKubaparisQuery } from '$gen/graphql';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';

    export let query: AboutKubaparisQuery;

    $: content =
        query && query.entry?.__typename === 'aboutKubaparis_aboutKubaparis_Entry'
            ? query.entry
            : null;

    // $: if (content) console.log({ content });

    /** TS Stuff */
    type PortraitImg = Extract<
        Extract<
            Extract<
                AboutKubaparisQuery['entry'],
                { __typename: 'aboutKubaparis_aboutKubaparis_Entry' }
            >['team'][number],
            { __typename: 'team_member_BlockType' }
        >['portrait'][number],
        { __typename: 'assets_Asset' }
    >;
    const isPortraitImg = (item): item is PortraitImg => {
        return (item as PortraitImg).__typename === 'assets_Asset';
    };
</script>

{#if content}
    <SeoMetaTags seo={content.seo} />

    <section class="mb-5 min-h-screen space-y-5 text-xl leading-5 md:text-2xl md:leading-6 lg:mt-5">
        <div class="whitespace-pre-line">
            {@html content.redactor}
        </div>
        <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
            {#each content.team as member}
                <article class="">
                    <figure>
                        {#each member.portrait.filter(isPortraitImg) as pic (pic.id)}
                            {#if pic.__typename === 'assets_Asset'}
                                <img
                                    class="w-full object-contain"
                                    src={pic.url}
                                    alt=""
                                    srcset={pic.srcset}
                                    width={pic.width}
                                    height={pic.height}
                                />
                            {/if}
                        {/each}
                        <figcaption class="mt-1">
                            <p>
                                {member.position}
                            </p>
                            <p class="ml-5">
                                <a href={member.socialMediaLink} rel="external">
                                    @{member.fullName}
                                </a>
                            </p>
                        </figcaption>
                    </figure>
                </article>
            {/each}
        </div>
        <div class="about-text indent-p-after-h2 col-start-1">
            {@html content.contactKubaparis}
        </div>
    </section>
{/if}

<style>
    .indent-p-after-h2 > :global(h2 + p) {
        @apply ml-5;
    }

    .about-text :global(p + h2),
    .about-text :global(p + p) {
        margin-top: theme('spacing.5');
    }
    .about-text :global(a) {
        @apply text-blue;
    }
</style>
